import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Lager 1",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#069378",
      d: "M488.68 250.21h-.01c-8 7.46-20.49 7.01-27.92-.99l-99.34-106.86v101.05c0 101.75-82.49 184.24-184.24 184.24H24.77c-5.44 0-10.38-2.21-13.96-5.78a19.67 19.67 0 0 1-5.78-13.96c0-10.9 8.84-19.74 19.74-19.74h152.39c79.95 0 144.76-64.8 144.76-144.75V142.29l-99.39 106.94c-7.42 8-19.93 8.45-27.91 1h-.03c-7.97-7.45-8.42-19.93-1-27.91L327.16 78.65c7.81-8.41 21.11-8.41 28.93 0l133.6 143.67c7.43 7.98 6.98 20.46-1 27.9Z"
    }, null, -1)
  ]))]))
}
export default { render: render }